import { PropsWithChildren } from "react";
import styles from "./UserHintsComponentWrapper.module.scss";

export type UserHintsComponentWrapperProps = PropsWithChildren<{
    errorMessage?: string;
    helperMessage?: string;
}>;

export const UserHintsComponentWrapper = ({
    errorMessage,
    helperMessage,
    children,
}: UserHintsComponentWrapperProps) => {
    return (
        <div
            className={`${styles.UserHintsComponentWrapper} ${
                errorMessage != null ? styles.error : ""
            }`}
        >
            {children}
            <div className={`${styles.helperText} ${errorMessage != null ? styles.error : ""}`}>{`${
                helperMessage ?? ""
            }${errorMessage != null ? ` ${errorMessage}` : ""}`}</div>
        </div>
    );
};
